<div class="content-panel-container">
    <ng-content></ng-content>
</div>